import { render, staticRenderFns } from "./Integrated.vue?vue&type=template&id=2908b337&scoped=true"
import script from "./Integrated.vue?vue&type=script&lang=js"
export * from "./Integrated.vue?vue&type=script&lang=js"
import style0 from "./Integrated.vue?vue&type=style&index=0&id=2908b337&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2908b337",
  null
  
)

export default component.exports